import React from "react";

const Textarea = (props) => {
  const {
    boxStyle,
    inputStyle,

    name,
    id,
    placeholder,
    rows,
    value,
    onChange = () => {},
    onBlur = () => {},
    hasError = false,
    errorMessage = "error",
  } = props;
  return (
    <span className={boxStyle}>
      <textarea
        className={inputStyle}
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows}
        wrap="soft"
      />
      <p className={`text-red-500 ${hasError ? "opacity-1 " : "opacity-0"}`}>
        {errorMessage}
      </p>
    </span>
  );
};

export default Textarea;
